import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  createStyles,
  Theme,
  makeStyles,
  Button,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  }),
);

interface IProps {
  open: boolean;
  title: string;
  messages?: { key: string; message: string }[];
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const DialogWarningMessage: React.FC<IProps> = ({
  open,
  title,
  messages = [],
  setOpen,
}) => {
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };
  return messages.length > 0 ? (
    <Dialog onClose={handleClose} aria-labelledby="aviso" open={open} PaperProps={{style: {width: 600}}}>
      <DialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{title}</Typography>
        {handleClose && (
          <IconButton
            aria-label="fechar-aviso"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {messages.map((item) => (
          <Typography>{item.message}</Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    <></>
  );
};

export default DialogWarningMessage;
